/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { createConversationPhraseListStore } from 'src/luis/core/stores/conversationPhraseListStore';
import { PhraseList } from 'src/luis/modules/features/types/PhraseList';
import { PhraseListSwagger } from 'src/luis/modules/features/types/PhraseListSwagger';
import { PhraseListStore } from 'src/luis/types/stores/features/PhraseListStore';

/**
 * Converts the phrase list swagger type to the store type.
 *
 * @param phraseList The swagger object from the api.
 * @returns The store object.
 */
export const phraseListSwaggerToPhraseListStore = (phraseList: PhraseListSwagger): PhraseListStore =>
    createConversationPhraseListStore(phraseList.id, {
        name: phraseList.name,
        phrases: phraseList.phrases.split(','),
        isActive: phraseList.isActive,
        isExchangeable: phraseList.isExchangeable,
        isGlobal: phraseList.enabledForAllModels
    });

/**
 * Converts the phrase list object type to phrase list swagger.
 *
 * @param phraseList The phrase list object.
 * @returns The swagger object.
 */
export const phraseListStoreToPhraseListSwagger = (phraseList: PhraseList): PhraseListSwagger => ({
    id: <number>phraseList.id,
    name: phraseList.name,
    isActive: phraseList.isActive,
    phrases: phraseList.phrases.toString(),
    enabledForAllModels: phraseList.isGlobal,
    isExchangeable: phraseList.isExchangeable
});
